/**
 * Nilgiri Marten, Blog Shelf (retired)
 *
 * The automatic "From our shelf" injection has been switched off. Every blog
 * post now carries its own signature coloured "From our shelf" block in the
 * post body, so this script no longer adds one and no longer runs on load.
 *
 * The BlogBuyNow class and the window.BlogBuyNow global are kept as harmless
 * no-ops so any older call site that still references them will not error.
 */

class BlogBuyNow {
  auto() {}
  static addButton() {}
}

window.BlogBuyNow = BlogBuyNow;